import { Box, Typography, Button } from "@mui/material";
import { Plus } from "@phosphor-icons/react";
import { StyledQuotesPage } from "./quotes.styled";
import { useContext, useState } from "react";
import { LanguageContext } from "../../globals/LanguageContext";
import { useNavigate } from "react-router-dom";

export const QuotesPage = () => {
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const { dictionary } = useContext(LanguageContext);
  const navigate = useNavigate();

  return (
    <StyledQuotesPage>
      <Box className="header">
        <Typography variant="h1">{dictionary.pages.quotes.title}</Typography>
        <Box className="buttonWrapper">
          <Button
            variant="outlined"
            className="addBtn"
            onClick={() => setDarkOverlayOpened(true)}
          >
            <Plus size={32} weight="bold" />
            {dictionary.pages.quotes.buttons.add}
          </Button>
          <Button
            variant="outlined"
            className="createBtn"
            onClick={() => navigate("/quotes/newQuote")}
          >
            <Plus size={32} weight="bold" />
            {dictionary.pages.quotes.buttons.create}
          </Button>
        </Box>
      </Box>
    </StyledQuotesPage>
  );
};
